'use strict';

var _ = require('lodash');
var AlertsPanelAggregationFactory = function AlertsPanelAggregationFactory(DataAggregationFactory) {
  function AlertsPanelAggregation() {
    DataAggregationFactory.call(this, 'fim-dashboard', 'dashboard-alerts-panel');
  }
  AlertsPanelAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  AlertsPanelAggregation.constructor = AlertsPanelAggregation;
  AlertsPanelAggregation.prototype.aggregate = function (data) {
    return _.filter([{
      name: 'Missing Fare',
      score: _.sumBy(data, 'fareDefaultingScore')
    }, {
      name: 'Inversion Correction',
      score: _.sumBy(data, 'fareInversionScore')
    }], 'score');
  };
  return AlertsPanelAggregation;
};
AlertsPanelAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = AlertsPanelAggregationFactory;